import React from 'react';
import './InputValidationError.scss';

function InputValidationError({ error, messages }) {
    return Object.entries(messages).map(([key, val]) =>
        error && error.type === key ? (
            <div className="input-validation-error text-danger mt-2 font-weight-bold">
                {val}
            </div>
        ) : null
    );
}

export default InputValidationError;
